import React from 'react';
import HomeComponent from '../../../components/Visitor/Home/Home';

const Home = () => {
    return (
        <div className="min-h-screen">
             <HomeComponent />
        </div>
    );
};

export default Home;
